import { RootState } from 'store';
import { IRightsResponse } from 'types/roles-and-rights.interface';

export const getRightsSelector = (store: RootState): IRightsResponse | null => store.rights.rightsList || null;
export const isRightsFirstCallSelector = (store: RootState): boolean => store.rights.isLoading;
export const getRightsIsLoadingSelector = (store: RootState): boolean => store.rights.isLoading;
